module.exports = __webpack_public_path__ + "static/media/farmers-logo.87b92ce6.svg";